import CompletedEPTourList from './CompletedEPTourList';

export default CompletedEPTourList;
